export enum ErrorCodes {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  NOT_EXIST = 422,
}

interface IErrorInfo {
  title: string
  subtitle: string
  statusCode: ErrorCodes
}

export const ErrorInfo: Record<ErrorCodes, IErrorInfo> = {
  [ErrorCodes.UNAUTHORIZED]: {
    title: 'Ошибка авторизации',
    subtitle: 'Сервис недоступен. Повторите авторизацию позднее',
    statusCode: ErrorCodes.UNAUTHORIZED,
  },
  [ErrorCodes.FORBIDDEN]: {
    title: 'Отказано в доступе',
    subtitle:
      'Доступ к странице ограничен специальными правами. Обратитесь к администратору, для получения доступа',
    statusCode: ErrorCodes.FORBIDDEN,
  },
  [ErrorCodes.NOT_FOUND]: {
    title: 'Запрошенная страница не существует',
    subtitle:
      'Пожалуйста воспользуйтесь навигацией или формой поиска, чтобы найти интересующую Вас информацию.',
    statusCode: ErrorCodes.NOT_FOUND,
  },
  [ErrorCodes.NOT_EXIST]: {
    title: 'По указанному ID ничего не найдено',
    subtitle: 'Уточните ID',
    statusCode: ErrorCodes.NOT_FOUND,
  },
}
